<div class="change-password-dialog">
    <div class="dialog-content">
        <div class="row space-between">
            <div class="icon">
                <rr-icon name="locked"></rr-icon>
            </div>

            <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
        </div>
        <div class="dialog-text">
            <h3 i18n>Change Password</h3>
            <div>Change your password to keep your account secure.</div>
            <div class="spacing w100"></div>
            <rr-input type="password" label="Old Password" [FormControl]="oldPassword"></rr-input>
            <rr-input type="password" label="New Password" [verifyPassword]="true"
                [FormControl]="newPassword"></rr-input>
            <rr-input type="password" label="Confirm New Password" [verifyPassword]="true"
                [FormControl]="confirmPassword"></rr-input>
        </div>
    </div>
    <div class="dialog-actions w100">
        <rr-btn type="Secondary" size="Medium" (btnclick)="close()">Cancel</rr-btn>
        <rr-btn type="Primary" size="Medium"
            [disabled]="!oldPassword.value.length || !newPassword.value.length || !confirmPassword.value.length || !samePasswords || !newPassword.valid"
            (btnclick)="changePw()">Change</rr-btn>
    </div>
</div>
